var map = {
	"./config-landing/_index.js": "KAsz",
	"./dashboard/_index.js": "0MYX",
	"./feedback-suggestions/_index.js": "nA3J",
	"./forums-archieve/_index.js": "3z3l",
	"./gallery-folders-archieve/_index.js": "95zg",
	"./gallery-folders/_index.js": "RYLz",
	"./master-data/_index.js": "Hhjg",
	"./news-archieve/_index.js": "QYtr",
	"./news/_index.js": "jQBS",
	"./user-role/_index.js": "/wLf",
	"./voting-archieve/_index.js": "LMfj",
	"./voting/_index.js": "5LU7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wGqA";


//////////////////
// WEBPACK FOOTER
// ./src/modules _index\.js$
// module id = wGqA
// module chunks = 44